import { lazy } from 'react'
import yn from 'yn'

const fallback = null
const env = process.env

const features = Object.freeze({
  RedirectCustomConexxeFeature: yn(
    env.REACT_APP_CONEXXE_TOGGLE_REDIRECT
  )
    ? lazy(() => import('../RedirectCustom/RedirectConexxe/RedirectConexxe'))
    : fallback,
  RedirectCustomZendeskFeature: yn(
    env.REACT_APP_ZENDESK_TOGGLE_REDIRECT
  )
    ? lazy(() => import('../RedirectCustom/RedirectZendesk/RedirectZendesk'))
    : fallback,
  RedirectCustomContactZendeskFeature: yn(
    env.REACT_APP_ZENDESK_TOGGLE_REDIRECT
  )
    ? lazy(() => import('../RedirectCustom/RedirectZendesk/RedirectContactZendesk'))
    : fallback,
  ZendeskWebWidget: yn(env.REACT_APP_HAS_ZENDESK_WEBWIDGET)
    ? lazy(() => import('Widgets/Zendesk'))
    : fallback,
  SalesForceWebWidget: yn(env.REACT_APP_HAS_CHATBOT_SALESFORCE)
    ? lazy(() => import('Widgets/SalesForce'))
    : fallback,
  CupomFeature: yn(env.REACT_APP_COUPON_DISCOUNT)
    ? lazy(() => import('features/Checkout/Summary/Coupon/Coupon'))
    : fallback,
  TourGuide: yn(env.REACT_APP_TOUR_GUIDE)
    ? lazy(() => import('App/TourGuide/TourHomePage'))
    : fallback,
  CashBackBF: yn(env.REACT_APP_HAS_CASHBACK_BF)
    ? lazy(() => import('Catalog/Availability/CashBackBF'))
    : fallback,
  CashBackBonus: yn(env.REACT_APP_HAS_CASHBACK_BF)
    ? lazy(() => import('Catalog/Availability/CashBackBonus'))
    : fallback,
  HeaderFeature: env.REACT_APP_HEADER_COMPONENT
    ? lazy(() => import(`App/Header/${env.REACT_APP_HEADER_COMPONENT}`))
    : lazy(() => import('App/Header/DefaultHeader')),
  SearchFeature: env.REACT_APP_SEARCH_COMPONENT
    ? lazy(() => import(`App/Header/Search/${env.REACT_APP_SEARCH_COMPONENT}`))
    : lazy(() => import('App/Header/Search/Search')),
  UserProfileFeature: env.REACT_APP_USER_PROFILE_COMPONENT
    ? lazy(() => import(`App/Header/UserProfile/${env.REACT_APP_USER_PROFILE_COMPONENT}`))
    : lazy(() => import('App/Header/UserProfile/UserProfile')),
  HelperChat: env.REACT_APP_CHAT_URL && env.REACT_APP_CHAT_ID
    ? lazy(() => import('features/Faq/HelperChat'))
    : fallback,
  SideChat: env.REACT_APP_CHAT_URL && env.REACT_APP_CHAT_ID
    ? lazy(() => import('features/Contact/SideChat'))
    : fallback,
  MileageHowToUse: yn(env.REACT_APP_FUELCREDIT_HOWTOUSE)
    ? lazy(() => import('features/FuelCredit/HowToUse'))
    : fallback,
  ForceUpgradeInsecureRequests: yn(env.REACT_APP_FORCE_UPGRADE_INSECURE_REQUESTS)
    ? lazy(() => import('App/Shell/ForceUpgradeInsecureRequests'))
    : fallback
})

export default features



// WEBPACK FOOTER //
// ./src/features/ToggleFeature/Features.js